import React from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { CreatableClearableSelector } from '../Selects/CreatableClearableSelector';
import { Option } from '../Selects/Selector';

const DICTIONARY_TYPE = 'Pozycje faktur';

interface SalesInvoicePositionNameCreatableSelectorProps {
  value?: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export const SalesInvoicePositionNameCreatableSelector: React.FC<
  SalesInvoicePositionNameCreatableSelectorProps
> = ({ value, onChange, readOnly }) => {
  const spd = useSpdCore();

  const provider = async (text: string): Promise<Option[]> => {
    const items = await spd.dictionaries.getByDictionaryType(DICTIONARY_TYPE);
    return items
      .filter(item => item.value.toLowerCase().includes(text.toLowerCase()))
      .map(item => ({
        value: item.value,
        label: item.value,
      }));
  };

  const handleChange = (option: Option) => {
    onChange(option?.value || '');
  };

  return (
    <CreatableClearableSelector
      value={value}
      provider={provider}
      onChange={handleChange}
      readOnly={readOnly}
      placeholder="Wybierz lub wpisz nazwę..."
    />
  );
};
